/** HTTP client options for ky (retries, timeout). */
export const KY_OPTIONS = {
  retry: 3,
  timeout: 30000,
} as const;

/**
 * `POST /cases/review/` waits on an LLM rewrite, and its time grows with the test: ~7 s for a
 * line, ~19 s for 2 000 characters (measured 2026-10-22). Longer tests ran past the default
 * 30 s, so this one call gets a ceiling of its own.
 */
export const AI_REVIEW_TIMEOUT_MS = 120_000;
